import { Box, ToggleButton, ToggleButtonGroup } from '@mui/material';
import Header from '../../components/special/Header';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { ProjectControllingList } from './ProjectControllingList';

const ProjectControlling = () => {
  const { t } = useTranslation();
  const [projectStatus, setProjectStatus] = useState('active');

  return (
    <>
      <Box className="flex gap-0 md:gap-8 md:items-center justify-between md:justify-start pr-2 md:flex-row flex-col pb-4 md:pb-0">
        <Header title={t('Project Controlling')} />
        <ToggleButtonGroup
          size="small"
          value={projectStatus}
          exclusive
          onChange={(e) => setProjectStatus(e.target.value)}
          aria-label="Project Status"
          className="backdrop-blur-lg"
        >
          <ToggleButton value="active">{t('Active')}</ToggleButton>
          <ToggleButton value="archive">{t('Finished')}</ToggleButton>
        </ToggleButtonGroup>
      </Box>
      <ProjectControllingList projectStatus={projectStatus} />
    </>
  );
};

export default ProjectControlling;
